import React from 'react';

import { ActionIcon, MantineSize, Popover, PopoverProps } from '@mantine/core';
import { IconHelpSquare } from '@tabler/icons-react';

interface HelpButtonProps extends PopoverProps {
  size?: MantineSize;
  actionIconProps?: React.ComponentProps<typeof ActionIcon>;
  iconWidth?: number;
}

const HelpButton = ({ children, actionIconProps, iconWidth, ...props }: HelpButtonProps): JSX.Element => {
  return (
    <Popover shadow='lg' radius='md' withArrow {...props}>
      <Popover.Target>
        <ActionIcon variant='subtle' color='kiloBlue' {...actionIconProps}>
          <IconHelpSquare width={iconWidth} />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown>{children}</Popover.Dropdown>
    </Popover>
  );
};

export default HelpButton;
export type { HelpButtonProps };
